import { useLinkTo } from '@react-navigation/native';
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import theme from 'theme';
import { calcSizeForTv } from 'utils/index';

import Button from 'components/Button';

const EmptyFavorites: React.FC = () => {
  const linkTo = useLinkTo();

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Sua lista está vazia</Text>
      <Text style={styles.description}>
        Adicione seus conteúdos favoritos em sua lista para assistir quando quiser
      </Text>
      <Button
        useTVFocus
        hasTVPreferredFocus
        textStyle={{ fontSize: calcSizeForTv(24) }}
        onPress={() => linkTo('/')}>
        Tela inicial
      </Button>
    </View>
  );
};

export default EmptyFavorites;

const styles = StyleSheet.create({
  container: {
    height: calcSizeForTv(600),
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    color: 'white',
    fontSize: calcSizeForTv(42),
    lineHeight: calcSizeForTv(60),
    fontFamily: theme.fonts.inter.black,
  },
  description: {
    color: 'white',
    fontFamily: theme.fonts.inter.regular,
    fontSize: calcSizeForTv(28),
    lineHeight: calcSizeForTv(40),
    maxWidth: calcSizeForTv(800),
    textAlign: 'center',
    marginTop: calcSizeForTv(20),
    marginBottom: calcSizeForTv(40),
  },
});
